module.exports = __webpack_public_path__ + "static/tax-saving-ae93a86a774e35e1ae585c26a2e3afbb.svg";